import { PageContainer } from '../../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { PageDefaultSegment, useFeedback } from "@sis/react-library";
import { useState } from 'react';
import { FormSamplesOutput } from '../FormSamplesOutput';
import { callMimicApi } from '../../../../utils/commonUtils';
import { FormSamplesSubmitButtonOnlyForm } from './FormSamplesSubmitButtonOnlyForm';
import { FormSamplesSubmitButtonOnlyPageInfo } from './FormSamplesSubmitButtonOnlyPageInfo';

/////////////////////////////////////////////////////////////////////////////////////////////
// Existing interface (would be defined elsewhere in the project).
/////////////////////////////////////////////////////////////////////////////////////////////
export interface ExampleDto {
    firstName: string;
    lastName: string;
}

export const FormSamplesSubmitButtonOnlyPage = () => {

  const [submittedValues, setSubmittedValues] = useState<ExampleDto | undefined>(undefined)
  const [submitting, setSubmitting] = useState(false);
  const { showError } = useFeedback();

  const handleSubmit = async (values: ExampleDto) => {
    setSubmitting(true);
    setSubmittedValues(values);

    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      await callMimicApi();
    } catch (ex) {
      showError(`An error occured: ${ex}`);
      return false;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PageContainer
      heading='Form Samples - Submit Button Only'
      icon={<TextSnippetIcon />}
      pageInfo={<FormSamplesSubmitButtonOnlyPageInfo />}
    >
      <PageDefaultSegment width={400}>
        <FormSamplesSubmitButtonOnlyForm
          submitting={submitting}
          onSubmit={handleSubmit}
        />
      </PageDefaultSegment>
      <FormSamplesOutput width={400} submittedValues={submittedValues} />
    </PageContainer>
  )
}
